import script from "./InsightMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./InsightMenu.vue?vue&type=script&lang=ts&setup=true"

import "./InsightMenu.vue?vue&type=style&index=0&id=2d46a02a&lang=css"

const __exports__ = script;

export default __exports__